/** ******************************************************************************* */
/* Marker list -- showing markers on the map                                      */
/** ******************************************************************************* */
Bingo.Map.MarkerList = function (mapSelector, listSelector, originPage) {
    Bingo.Map.Instance.call(this, Bingo.Map.MODE_MARKER_LIST, mapSelector, originPage);

    this.window = null;
    this.list = [];
    this.clusterer = null;

    this.listSelector = listSelector;
    this.localitiesToLoad = [];
    this.localitiesDetail = [];

    this.ONE_MARKER_ZOOM_LEVEL = 14;
};
Bingo.Map.MarkerList.prototype = Object.create(Bingo.Map.Instance.prototype);


Bingo.Map.MarkerList.prototype.init = function () {
    if (!this.getArea()) {
        Bingo.Map.Instance.prototype.init.call(this, null, true);
        if (!this.getArea()) {
            this.showLoadingFailed();
        }
        this.clusterer = this.createMarkerClusterer(this.getArea(), this.list);
        this.initBlocksHover();
        this.addCenterButton();
    }
};

Bingo.Map.MarkerList.prototype.removeMarkers = function () {
    for (const index in this.list) {
        const marker = this.list[index];
        const instance = marker._instance;
        if (instance.window) {
            instance.window.close();
        }
        marker.setMap(null);
        if (marker._circle) {
            marker._circle.setMap(null);
        }
        if (marker._label) {
            marker._label.setMap(null);
        }
        if (marker._polygon) {
            marker._polygon.setMap(null);
        }
    }
    this.localitiesToLoad = [];
    this.clusterer.clearMarkers();
    this.list = [];
};

Bingo.Map.MarkerList.prototype.addCenterButton = function () {
    const self = this;
    this.addButton(google.maps.ControlPosition.RIGHT_TOP, 'gm-location-btn', () => {
        self.fitBounds();
    });
};

Bingo.Map.MarkerList.prototype.initBlocksHover = function () {
    if (!this.listSelector) {
        return;
    }
    const self = this;
    $(`#${this.listSelector} div[data-marker-list-highlight]`).not('[data-marker-list-initialized]').each((index, item) => {
        const el = $(item);
        el.attr('data-marker-list-initialized', true);
        el.hover(() => {
            const itemId = el.data('marker-list-highlight');
            const markers = self.list.filter(marker => marker._itemId === itemId);

            if (markers.length > 0) {
                markers.forEach((marker) => {
                    google.maps.event.trigger(marker, 'mouseover');
                    const cluster = self.clusterer.getClusterWithMarker(marker);
                    if (cluster) {
                        google.maps.event.trigger(cluster.getClusterIcon().getWrapper(), 'mouseover');
                    }
                });
            }
        }, () => {
            const itemId = el.data('marker-list-highlight');
            const markers = self.list.filter(marker => marker._itemId === itemId);

            if (markers.length > 0) {
                markers.forEach((marker) => {
                    google.maps.event.trigger(marker, 'mouseout');
                    const cluster = self.clusterer.getClusterWithMarker(marker);
                    if (cluster) {
                        google.maps.event.trigger(cluster.getClusterIcon().getWrapper(), 'mouseout');
                    }
                });
            }
        });
    });
};

Bingo.Map.MarkerList.prototype.getLocalitiesDetailedData = function (localityIdsUniq) {
    $.nette.ajax({
        type: 'GET',
        url: '/api/v1/locality/details',
        data: { localityIds: localityIdsUniq },
        success: (returnData) => {
            returnData.data.data.forEach((returnLocality) => {
                this.localitiesDetail[parseInt(returnLocality.id)] = returnLocality;
            });
            this.loadAddedLocalities(true);
        },
    });
};

Bingo.Map.MarkerList.prototype.loadAddedLocalities = function (forbidLoad) {
    let localityIdsAll = [];
    this.localitiesToLoad.forEach((locality) => {
        localityIdsAll = [...localityIdsAll, ...locality.localityId];
    });
    //  remove duplicates from array and change back from set to array
    const localityIdsAllUniq = [...new Set(localityIdsAll)];

    //  get all not loaded localities
    const localitiesToLoad = localityIdsAllUniq.filter(value => typeof this.localitiesDetail[value] === 'undefined');

    if (localitiesToLoad.length > 0) {
        if (typeof forbidLoad !== 'undefined' && forbidLoad) {
            // there are localities, that should be loaded, but weren't => log error
            console.error('Locality data are not complete.');
        } else {
            this.getLocalitiesDetailedData(localitiesToLoad);
        }
    } else {
        this.localitiesToLoad.forEach((locality) => {
            const localityIds = locality.localityId;
            const {
                itemId, color, price, info, info2, windowClass,
            } = locality;

            localityIds.forEach((localityId) => {
                const localityDetail = this.localitiesDetail[localityId];
                if (localityDetail !== 'undefined') {
                    if (typeof localityDetail.area !== 'undefined') {
                        this.addPolygon(
                            localityDetail.area,
                            itemId,
                            color,
                            price,
                            info,
                            info2,
                            windowClass,
                        );
                    } else if (typeof localityDetail.circle !== 'undefined') {
                        this.addCircleAndMarker(
                            this.extractCoordinatesFromDbPoint(localityDetail.circle.center),
                            localityDetail.circle.radius * 1000,
                            itemId,
                            color,
                            price,
                            info,
                            info2,
                            windowClass,
                        );
                    }
                }
            });
        });
        this.fitBounds();
    }
};

Bingo.Map.MarkerList.prototype.fitBounds = function (stick) {
    if (this.list.length === 0) {
        if (!stick) {
            this.centerOnDefault();
        }
        return;
    }
    const bounds = new google.maps.LatLngBounds();
    $.each(this.list, function (index, marker) {
        if (marker.hasOwnProperty('_circle')) {
            bounds.union(marker._circle.getBounds());
        } else if (marker.hasOwnProperty('_polygon')) {
            this._polygon.getPath().forEach((element) => {
                bounds.extend(element);
            });
        } else {
            bounds.extend(marker.position);
        }
    });
    Bingo.Map.Instance.prototype.fitBounds.call(this, bounds, this.ONE_MARKER_ZOOM_LEVEL);
};
Bingo.Map.MarkerList.prototype.findMarker = function (itemId) {
    for (let i = 0; i < this.list.length; i++) {
        const marker = this.list[i];
        if (marker._itemId === itemId) {
            return marker;
        }
    }
    return null;
};
Bingo.Map.MarkerList.prototype.addMarker = function (location, radius, polygon, localityId, itemId, color, price, info, info2, windowClass) {
    if (localityId !== null && localityId.length !== 0) {
        this.localitiesToLoad.push(
            {
                localityId, itemId, color, price, info, info2, windowClass,
            },
        );
    } else if (radius > 0) {
        this.addCircleAndMarker(location, radius, itemId, color, price, info, info2, windowClass);
    } else if (polygon !== null) {
        this.addPolygon(polygon, itemId, color, price, info, info2, windowClass);
    } else {
        marker = this.drawMarker(location, itemId, color, price, info, info2, windowClass);
        this.clusterer.addMarker(marker);
        this.list.push(marker);
    }
};

Bingo.Map.MarkerList.prototype.getPolygonPoints = function (polygon) {
    const points = [];

    if (!polygon || polygon === null) {
        return points;
    }
    const pointsRaw = polygon.split(';');
    for (let i = 0; i < pointsRaw.length; i++) {
        //  get rid of last point, which is beggining
        if (i === (pointsRaw.length - 1) && pointsRaw[0] === pointsRaw[pointsRaw.length - 1]) {
            break;
        }
        points.push(this.extractCoordinates(pointsRaw[i]));
    }

    return points;
};

Bingo.Map.MarkerList.prototype.addPolygon = function (polygon, itemId, color, price, info, info2, windowClass) {
    polygonPoints = this.getPolygonPoints(polygon);
    marker = this.drawMarker(polygonPoints[0], itemId, color, price, info, info2, windowClass);

    const newPolygon = {
        strokeColor: Bingo.Map.Marker.COLOR[color],
        strokeWeight: Bingo.Map.Marker.RADIUS_BORDER,
        fillColor: Bingo.Map.Marker.COLOR[color],
        fillOpacity: Bingo.Map.Marker.RADIUS_OPACITY,
        clickable: false,
        editable: false,
        zIndex: 1,
    };

    newPolygon.paths = polygonPoints;
    newPolygon.map = this.getArea();

    marker._polygon = new google.maps.Polygon(newPolygon);

    this.clusterer.addMarker(marker);
    this.list.push(marker);
};

Bingo.Map.MarkerList.prototype.copyInfo = function (marker) {
    let type = '';
    switch (this._originPage) {
        case Bingo.Map.ORIGIN_PAGE_MODE.DEMAND_LIST:
            type = 'demand';
            break;
        case Bingo.Map.ORIGIN_PAGE_MODE.OFFER_LIST:
            type = 'offer';
            break;
        default:
            return null;
    }
    const wrapperDiv = $(`#${type}_${marker._itemId}`);
    if (wrapperDiv !== null && wrapperDiv.length > 0) {
        let info = `<div class="offer-minipreview-panel" id="wrapper_${type}_${marker._itemId}_map">`;
        info += wrapperDiv.prop('outerHTML').replace(/id="/g, 'id="map-').replace(/-small/g, '');
        info += '</div>';
        return info;
    }
    return null;
};

Bingo.Map.MarkerList.prototype.drawMarker = function (location, itemId, color, price, info, info2, windowClass) {
    const marker = new google.maps.Marker({
        map: this.getArea(),
        anchorPoint: new google.maps.Point(0, -29),
        draggable: false,
        optimized: false,
        cursor: (info) ? 'pointer' : 'url("https://maps.gstatic.com/mapfiles/openhand_8_8.cur")', // to prevent irrelevant drag cursor when not openable
        _itemId: itemId,
        _info: (info) || null,
        _info2: (info2) || null,
        _windowClass: (windowClass) || null,
        zIndex: 5000 - this.list.length,
        _zIndex: 5000 - this.list.length,
    });
    const isHighlighted = color.toString().search('_highlighted') > 0;
    marker.setIcon(({
        url: `/src/images/markers/${color}.png?{{buildVersion}}`,
        origin: new google.maps.Point(0, 0),
        anchor: isHighlighted ? new google.maps.Point(23, 42) : new google.maps.Point(20, 42),
        size: isHighlighted > 0 ? new google.maps.Size(46, 54) : new google.maps.Size(40, 48),
        scaledSize: isHighlighted > 0 ? new google.maps.Size(46, 54) : new google.maps.Size(40, 48),
    }));
    marker._instance = this;
    marker._originalPosition = location;
    marker.setPosition(location);
    if (price) {
        const label = new MapLabel(marker, {
            text: price,
            map: this.getArea(),
            position: new google.maps.LatLng(location),
            fontSize: (/gold/i).test(color) ? 16 : 13,
            fontWeight: 'bold',
            fontColor: Bingo.Map.Marker.COLOR[color],
            strokeWeight: 3,
            strokeColor: (/gold/i).test(color) ? '#555555' : '#ffffff',
            align: 'center',
            zIndex: marker._zIndex,
        });
        marker.bindTo('position', label);
        marker._label = label;
    }

    if (marker._info === null) {
        marker._info = this.copyInfo(marker);
    }

    marker.addListener('click', () => {
        this.closeInfoWindow();
        if (marker._info !== null) {
            this.window = this.createInfoBox(marker);
        }
    });

    google.maps.event.addListener(marker, 'mouseover', () => {
        this.markerHover(marker);
    });
    google.maps.event.addListener(marker, 'mouseout', () => {
        this.markerDehover(marker);
    });

    return marker;
};


Bingo.Map.MarkerList.prototype.addCircleAndMarker = function (location, radius, itemId, color, price, info, info2, windowClass) {
    marker = this.drawMarker(location, itemId, color, price, info, info2, windowClass);

    const circle = new google.maps.Circle({
        map: this.getArea(),
        radius,
        strokeColor: Bingo.Map.Marker.COLOR[color],
        strokeWeight: Bingo.Map.Marker.RADIUS_BORDER,
        fillColor: Bingo.Map.Marker.COLOR[color],
        fillOpacity: Bingo.Map.Marker.RADIUS_OPACITY,
        draggable: false,
        editable: false,
        cursor: null, // to prevent irrelevant drag cursor
    });
    circle.bindTo('center', marker, 'position');
    marker._circle = circle;

    this.clusterer.addMarker(marker);
    this.list.push(marker);
};
